/* eslint-disable no-restricted-globals */
/* eslint-disable camelcase */
/* eslint-disable radix */
/* eslint-disable no-use-before-define */
/* eslint-disable no-shadow */
/* eslint-disable no-var */
/* eslint-disable vars-on-top */
/* eslint-disable no-restricted-properties */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-named-as-default */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-plusplus */
/* eslint-disable no-unused-vars */
import $ from 'jquery';
import Web3EthPersonal from 'web3-eth-personal';
import Web3 from 'web3';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import queryString from 'querystring';
import showOverlay from './utils/showOverlay';
import getContract from './utils/getContract';
import showAlert from './utils/showAlert';
import checkMetamask from './utils/checkMetamask';
import checkMetamaskWithoutEx from './utils/checkMetamaskWithoutEx';
import createTeam from './utils/createTeam';
import checkMyWalletBar from './utils/checkMyWalletBar';
import retryClaimToken from './utils/retryClaimToken';
import retryClaimNfsgxToken from './utils/retryClaimNfsgxToken';
import stakeTokens from './utils/stakeTokens';
import stakeNfsgxTokens from './utils/stakeNfsgxTokens';
import {
  updateSearch,
} from './constants';

import {
  statDetail,
  initMyTeam,
  initPlayerDetail,
  initClaim,
} from './pages';
import _t from './utils/translate';
import {
  block,
  unblock,
} from './utils/blocker';
import {
  matches,
  filters,
  initBuyTrainingCenter,
  initBuyFormation,
} from './widgets';
import claimTokens from './utils/claimTokens';
import claimNfsgxTokens from './utils/claimNfsgxTokens';
import reloadPartnershipItems from './utils/reloadPartnershipItems';
import reloadFormations from './utils/reloadFormations';
import {
  getToken,
  login,
} from './utils/login';
import filter from './widgets/filters/filters';
import spinWheel from './spinWheel';
import 'jquery-validation';
import {
  getTeamInfo,
  getVerifyCode,
  loginWithEmail, logoutRequest,
} from './utils/api/index';
import checkLogin from './utils/checkLogin';

function increaseValue() {
  let value = parseInt(document.getElementById('mint-count').value, 10);
  value = isNaN(value) ? 1 : value;
  value++;
  document.getElementById('mint-count').value = value;
}

function decreaseValue() {
  let value = parseInt(document.getElementById('mint-count').value, 10);
  value = isNaN(value) ? 2 : value;
  value < 2 ? value = 2 : '';
  value--;
  document.getElementById('mint-count').value = value;
}

const playerNameChange = function () {
  const playerNameChangeElement = $('.js-player-name-change');
  if (!playerNameChangeElement.length) {
    return;
  }
  playerNameChangeElement.on('click', async (e) => {
    if (!await login()) {
      unblock();
      return;
    }

    Swal.fire({
      title: _t('Change Player Name'),
      html: `<div style="margin-top: 30px">It will cost 1 $NFSG</div><input id="long-name" value="${playerNameChangeElement.data('long-name')}" placeholder="Name" name="long_name" class="swal2-input"> <input id="name" value="${playerNameChangeElement.data('name')}" placeholder="Short Name" name="name" class="swal2-input">`,
      inputAttributes: {
        autocapitalize: 'off',
      },
      customClass: {
        cancelButton: 'order-1',
        confirmButton: 'order-2',
        denyButton: 'order-3',
      },
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonText: _t('Send'),
      showLoaderOnConfirm: true,
      preConfirm: async () => new Promise((resolve, reject) => {
        resolve({
          Name: $('#name').val(),
          LongName: $('#long-name').val(),
        });
        // maybe also reject() on some condition
      }),
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((data) => {
      if (data.isConfirmed) {
        Swal.fire({
          title: _t('Warning!'),
          html: `<p style="margin-top: 90px" class="text-left">${_t('5 $NFSGX fee will be charged from your wallet. <br/> Are you sure?')}</p>`,
          showCancelButton: true,
          showCloseButton: true,
          confirmButtonText: _t('Sure!'),
          showLoaderOnConfirm: true,
          allowOutsideClick: () => !Swal.isLoading(),
        }).then(async (result) => {
          if (result.isConfirmed) {
            block();
            const msgData = {
              nft_id: playerNameChangeElement.data('id'),
              sessionKey: window.sessionKey,
              name: data.value.Name,
              long_name: data.value.LongName,
              generation: `${playerNameChangeElement.data('generation')}`,
            };

            $.post({
              url: '/api/player/nameChange',
              headers: {
                token: window.token,
              },
              data: msgData,
              success: (data) => {
                unblock();
                if (data.success) {
                  Swal.fire(
                    _t('Success!'),
                    data.message,
                    'success',
                  );

                  document.location.reload(true);
                } else {
                  Swal.fire(
                    _t('Error!'),
                    data.message,
                    'error',
                  );
                }
              },
              error(xhr, status, error) {
                // handle error
              },
            });
          }
        });
      }
    });
  });
};
const playerResetSkills = function () {
  const playerNameChangeElement = $('.js-remove-skills');
  if (!playerNameChangeElement.length) {
    return;
  }
  playerNameChangeElement.on('click', async (e) => {
    if (!await login()) {
      unblock();
      return;
    }
    const id = $(e.currentTarget).data('id');

    Swal.fire({
      title: _t('Reset Skills'),
      html: '<div style="margin-top: 30px">It will cost 300 NFSGx</div>',
      inputAttributes: {
        autocapitalize: 'off',
      },
      customClass: {
        cancelButton: 'order-1',
        confirmButton: 'order-2',
        denyButton: 'order-3',
      },
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonText: _t('Send'),
      showLoaderOnConfirm: true,
      preConfirm: async () => new Promise((resolve, reject) => {
        resolve({
          id,
        });
        // maybe also reject() on some condition
      }),
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((data) => {
      if (data.isConfirmed) {
        Swal.fire({
          title: _t('Warning!'),
          html: `<p style="margin-top: 90px" class="text-left">${_t('300 $NFSGX fee will be charged from your wallet. <br/> Are you sure?')}</p>`,
          showCancelButton: true,
          showCloseButton: true,
          confirmButtonText: _t('Sure!'),
          showLoaderOnConfirm: true,
          allowOutsideClick: () => !Swal.isLoading(),
        }).then(async (result) => {
          if (result.isConfirmed) {
            block();
            const msgData = {
              nft_id: playerNameChangeElement.data('id'),
              sessionKey: window.sessionKey,
            };

            $.post({
              url: '/api/player/resetSkill',
              headers: {
                token: window.token,
              },
              data: msgData,
              success: (data) => {
                unblock();
                if (data.success) {
                  Swal.fire(
                    _t('Success!'),
                    data.message,
                    'success',
                  );

                  document.location.reload(true);
                } else {
                  Swal.fire(
                    _t('Error!'),
                    data.message,
                    'error',
                  );
                }
              },
              error(xhr, status, error) {
                // handle error
              },
            });
          }
        });
      }
    });
  });
};

const displayOwnerActions = function () {
  //
  // const onlyOwnerElements = $('.js-owner-only, .js-not-owner-only');
  // if (!onlyOwnerElements.length) {
  //   return;
  // }
  //
  // let owner = onlyOwnerElements.data('owner');
  //
  // onlyOwnerElements.each(async function () {
  //   try {
  //     await checkMetamask();
  //     const accounts = await window.web3.eth.getAccounts();
  //
  //     if (!owner) {
  //       owner = await getContract().methods.ownerOf($(this).data('token-id')).call();
  //     }
  //
  //     if (!owner) {
  //       return;
  //     }
  //
  //     if (owner.toLowerCase() === accounts[0].toLowerCase()) {
  //       $('.js-owner-only').show();
  //       $('.js-not-owner-only').hide();
  //     } else {
  //       $('.js-owner-only').hide();
  //       $('.js-not-owner-only').show();
  //     }
  //   } catch (exception) {
  //     // nothing
  //   }
  // });
};


const mintNfts = () => {
  // console.log($('#mint-nfts, .mintNfts').leght);
  $('#mint-nfts, .mintNfts').on('click', async function () {
    showAlert({
      title: 'In Progress',
      message: 'Please wait while your transaction is in progress. You will be redirected to My Wallet page when the transaction succeeds.',
      icon: 'wait',
    });
    await checkMetamask();
    const accounts = await window.web3.eth.getAccounts();
    const balance = await window.web3.eth.getBalance(accounts[0]);
    const contract = getContract();
    const currentPrice = await contract.methods.calculatePrice().call();
    const possibleSales = Math.floor(balance / currentPrice);
    const count = $(this).data('count') > 1 ? $(this).data('count') : 1;
    const price = web3.utils.toWei((count * web3.utils.fromWei(currentPrice)).toString());

    if (count > possibleSales) {
      if (possibleSales) {
        showOverlay(`You can only get ${possibleSales} nft`, false);
      } else {
        showOverlay('You don\'t have enough token to get a nft', false);
      }

      return;
    }

    console.log(balance, currentPrice, possibleSales, price);

    try {
      const response = await contract.methods.getNfts(count).send(price, {
        from: accounts[0],
        value: price,
        maxPriorityFeePerGas: null,
        maxFeePerGas: null,
      }).on('Bought', () => {
      });

      if (response.status) {
        const options = {
          title: _t('Success!'),
          message: _t('Payment successful'),
          icon: 'success',
        };

        Swal.fire(options);

        $.post(`/api/nfts/updateSalesCount?chainId=${window.selectedChain === 'CHZ' ? window.chainIdChz : window.chainId}`, () => {
          window.location = `/my-team?chzClaim=1&address=${accounts[0]}&count=${count}`;
        });
      }
    } catch (error) {
      showAlert({ message: error.message, icon: 'error' });
      unblock();
    }
  });
};
const refreshAndReload = async (tokenId) => {
  $.post(`/api/avatar/update?id=${tokenId}`, () => {
    window.location.reload(true);
  });
};


const transferNft = async () => {
  const transferElements = $('.js-transfer');
  if (!transferElements.length) {
    return;
  }
  transferElements.on('click', async (e) => {
    checkMetamask(e);

    const itemNetwork = transferElements.data('network');
    if (window.selectedChain !== itemNetwork) {
      showOverlay(`Wrong network. Please switch your network to ${itemNetwork === 'CHZ' ? 'Chiliz ($CHZ)' : 'Avalanche ($AVAX)'}`, false);
      return;
    }

    Swal.fire({
      input: 'text',
      html: `
        <h3 style="margin-top: 40px;margin-bottom: 80px;">${_t('Target Address?')}</h3>
      `,
      inputValidator: result => !result && _t('You need to enter value'),
      inputAttributes: {
        autocapitalize: 'off',
      },
      customClass: {
        cancelButton: 'order-1',
        confirmButton: 'order-2',
        denyButton: 'order-3',
      },
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonText: _t('Send'),
      showLoaderOnConfirm: true,
      preConfirm: async (targetAddress) => {
        // let price = window.prompt('What is the price?');
        const isValidAddress = window.web3.utils.isAddress(targetAddress);
        if (!isValidAddress) {
          showAlert({
            message: _t('Please enter a valid address'),
            icon: 'error',
          });
        } else {
          Swal.fire({
            title: _t('Warning!'),
            html: `<p class="text-left" style="margin-top: 40px;">${_t('You will transfer your NFTSoccerGames to this address for free. Are you sure?')}</p>`,
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: _t('Sure!'),
            showLoaderOnConfirm: true,
            allowOutsideClick: () => !Swal.isLoading(),
          }).then(async (result) => {
            if (result.isConfirmed) {
              block();
              await checkMetamask();
              const accounts = await window.web3.eth.getAccounts();
              const contract = getContract();
              try {
                const response = await contract.methods.transferFrom(accounts[0], targetAddress, $(e.currentTarget).data('token-id')).send(0, {
                  from: accounts[0],
                  maxPriorityFeePerGas: null,
                  maxFeePerGas: null,
                });
                await refreshAndReload($(e.currentTarget).data('token-id'));
                window.location.reload(1);
              } catch (ex) {
                showAlert({ message: ex.message, icon: 'error' });
                unblock();
              }
            }
          });
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      if (result.isConfirmed) {
        if (result.value && result.value.status) {
          Swal.fire(
            _t('Success!'),
            'Send',
            'success',
          );
        }
      }

      await refreshAndReload($(e.currentTarget).data('token-id'));
      window.location.reload(1);
    });
  });
};

const reloadMyWallet = async () => {
  if (!$('.js-reload-my-wallet').length) {
    return;
  }

  // await checkMetamask();

  // const accounts = await window.web3.eth.getAccounts();
  // const address = accounts[0];

  const address = null;

  if (address) {
    $.post(`/api/notification/count?address=${address}&chainId=${window.selectedChain === 'CHZ' ? window.chainIdChz : window.chainId}`, (data) => {
      if (data.count > 0) {
        $('.js-notification-count').html(data.count).show();
      }
    });
  }

  // const ids = await getWallet();
  const updatedIds = [];

  const widgetId = $('.js-reload-my-wallet').data('cms_design_widget_id');
  // const totalAvatars = ids.length;
  // const updatedIds = ids.slice(0, 1000);
  const searchString = window.location.search.substring(1, window.location.search.length);
  let query = `info_item_id=${window.itemId}&cms_design_widget_id=${widgetId}&is_ajax=1&page_no=${window.currentPageNo}&${searchString}`;
  const params = queryString.parse(searchString);
  const token = getToken();
  console.log('widgetId', widgetId);
  if (window.inMyWallet && !params.address) {
    query += `&address=${address}&chainId=${window.selectedChain === 'CHZ' ? window.chainIdChz : window.chainId}&token=${token}`;
    console.log(query);
    updateSearch({
      key: 'url',
      value: 'my-players',
      unique: false,
      type: 'checkbox',
      action: 'ajax',
    });
  } else {
    $.post(`/ajax/widget/render?${query}&chainId=${window.selectedChain === 'CHZ' ? window.chainIdChz : window.chainId}&token=${token}`, `ids=${updatedIds.join(',')}`, (data) => {
      $(`.widget[data-design-widget-id="${widgetId}"]`).html(data);
      checkMyWalletBar();
      claimTokens();
      claimNfsgxTokens();
      retryClaimToken();
      retryClaimNfsgxToken();
      stakeTokens();
      stakeNfsgxTokens();
      filter();
    });
  }
};

const reloadMyWalletPage = async () => {
  if (!$('.js-load-my-wallet').length) {
    return;
  }

  await checkMetamask();

  const accounts = await window.web3.eth.getAccounts();
  const address = accounts[0];

  if (address) {
    $.post(`/api/notification/count?address=${address}&chainId=${window.selectedChain === 'CHZ' ? window.chainIdChz : window.chainId}`, (data) => {
      if (data.count > 0) {
        $('.js-notification-count').html(data.count).show();
      }
    });
  }

  // const ids = await getWallet();
  const updatedIds = [];

  const widgetId = $('.js-load-my-wallet').data('cms_design_widget_id');
  // const totalAvatars = ids.length;
  // const updatedIds = ids.slice(0, 1000);
  const searchString = window.location.search.substring(1, window.location.search.length);
  let query = `info_item_id=${window.itemId}&cms_design_widget_id=${widgetId}&is_ajax=1&page_no=${window.currentPageNo}&${searchString}`;
  const params = queryString.parse(searchString);
  console.log('widgetId', widgetId);
  const  token = getToken();
  if (window.inMyWallet && !params.address) {
    query += `&address=${address}&chainId=${window.selectedChain === 'CHZ' ? window.chainIdChz : window.chainId}&token=${token}`;
    console.log(query);
    updateSearch({
      key: 'url',
      value: 'my-players',
      unique: false,
      type: 'checkbox',
      action: 'ajax',
    });
  } else {
    $.post(`/ajax/widget/render?${query}&address=${address}&chainId=${window.selectedChain === 'CHZ' ? window.chainIdChz : window.chainId}&token=${token}`, `ids=${updatedIds.join(',')}`, (data) => {
      $(`.widget[data-design-widget-id="${widgetId}"]`).html(data);
      checkMyWalletBar();
      claimTokens();
      claimNfsgxTokens();
      retryClaimToken();
      retryClaimNfsgxToken();
      stakeTokens();
      stakeNfsgxTokens();
      filter();
    });
  }
};

const reloadMyTokens = async () => {
  if (!($('[data-widget="MyTokens"]').length || $('[data-widget="MyNfsgxTokens"]').length)) {
    return;
  }

  await checkMetamask();
  const ids = await getWallet();

  let widgetId = $('[data-widget="MyTokens"]').data('design-widget-id');
  if ($('[data-widget="MyNfsgxTokens"]').length) {
    widgetId = $('[data-widget="MyNfsgxTokens"]').data('design-widget-id');
  }
  const updatedIds = ids.slice(0, 1000);

  const accounts = await window.web3.eth.getAccounts();
  const address = accounts[0];
  const searchString = window.location.search.substring(1, window.location.search.length);

  $.post('/ajax/widget/render', `&info_item_id=${window.itemId}&cms_design_widget_id=${widgetId}&is_ajax=1&address=${address}&${searchString}&chainId=${window.selectedChain === 'CHZ' ? window.chainIdChz : window.chainId}`, (data) => {
    $(`.widget[data-design-widget-id="${widgetId}"]`).html(data);
    checkMyWalletBar();
    claimTokens();
    claimNfsgxTokens();
    retryClaimToken();
    retryClaimNfsgxToken();
    stakeTokens();
    stakeNfsgxTokens();
  });
};

const reloadMyMatches = async () => {
  if (!($('.widget_Tourney_MyMatches').length)) {
    return;
  }

  await checkMetamask();
  const ids = await getWallet();

  const widgetId = $('.widget_Tourney_MyMatches').data('design-widget-id');

  const accounts = await window.web3.eth.getAccounts();
  const address = accounts[0];
  const searchString = window.location.search.substring(1, window.location.search.length);

  $.post('/ajax/widget/render', `&info_item_id=${window.itemId}&cms_design_widget_id=${widgetId}&is_ajax=1&address=${address}&chainId=${window.selectedChain === 'CHZ' ? window.chainIdChz : window.chainId}&${searchString}`, (data) => {
    $(`.widget[data-design-widget-id="${widgetId}"]`).html(data);
  });
};

window.onunload = window.onbeforeunload = function () {
  if (window.hasActiveOperation) {
    return 'There is an active operation. Are you sure?';
  }
};

const getWallet = async () => {
  const contract = getContract();

  const accounts = await window.web3.eth.getAccounts();

  return await contract.methods.tokensOfOwner(accounts[0]).call();
};

const tierToggle = async () => {
  $('#tier-load-more').off('click').on('click', () => {
    $('#tierContent tr.hidden').toggle('slow', function () {
      if ($(this).hasClass('open')) {
        $('#tierContent span').html('Show More <i class="icofont-arrow-down"></i>');
      } else {
        $('#tierContent span').html('Collapse <i class="icofont-arrow-up"></i>');
      }

      $(this).toggleClass('open');
    });
  });
};

const localDatetime = function () {
  const dates = $('.local-datetime');
  if (tz === 'Europe/Istanbul') {
    return;
  }
  dates.each(function () {
    let time = $(this).data('datetime');
    if (!time) {
      return;
    }
    time *= 1000;
    const d = new Date(time);
    const text = d.toLocaleString('en-US', { timeZone: tz, hour12: false });
    $(this).text(text.substring(0, 17).replace(',', ''));
  });
};

const buyFromMarketplace = async () => {
  const marketplaceElements = $('.js-buy-nft');
  if (!marketplaceElements.length) {
    return;
  }

  marketplaceElements.on('click', async (e) => {
    if (!await checkMetamask()) {
      return;
    }

    block();

    const accounts = await web3Client.eth.getAccounts();
    const contract = getContract();
    const details = await contract.methods.Bazaar($(e.currentTarget).data('token-id')).call();
    const balance = await web3Client.eth.getBalance(accounts[0]) / Math.pow(10, 18);
    if (balance < (details.price / Math.pow(10, 18) + 0.05)) {
      Swal.fire(
        _t('Error!'),
        'You don\'t have enough balance',
        'error',
      );
      unblock();
      return;
    }

    try {
      showAlert({
        title: 'In Progress',
        message: 'Please wait while your transaction is in progress.',
        icon: 'wait',
      });

      await contract.methods.buyFromMarketplace($(e.currentTarget).data('token-id')).send(0, {
        from: accounts[0],
        value: details.price,
        maxPriorityFeePerGas: null,
        maxFeePerGas: null,
      });
      await refreshAndReload($(e.currentTarget).data('token-id'));
      window.location.reload(1);
    } catch (ex) {
      showAlert({ message: ex.message, icon: 'error' });
      unblock();
    }
  });
};

const removeFromMarketplace = async () => {
  const marketplaceElements = $('.js-remove-from-marketplace');
  if (!marketplaceElements.length) {
    return;
  }

  marketplaceElements.on('click', async (e) => {

    checkMetamask(e);

    const itemNetwork = marketplaceElements.data('network');
    if (window.selectedChain !== itemNetwork) {
      showOverlay(`Wrong network. Please switch your network to ${itemNetwork === 'CHZ' ? 'Chiliz ($CHZ)' : 'Avalanche ($AVAX)'}`, false);
      return;
    }

    const accounts = await web3Client.eth.getAccounts();
    const contract = getContract();

    try {
      showAlert({
        title: 'In Progress',
        message: 'Please wait while your transaction is in progress.',
        icon: 'wait',
      });

      await contract.methods.removeFromMarketplace($(e.currentTarget).data('token-id')).send(0, {
        from: accounts[0],
        maxPriorityFeePerGas: null,
        maxFeePerGas: null,
      });

      await refreshAndReload($(e.currentTarget).data('token-id'));
      window.location.reload(1);
    } catch (ex) {
      showAlert({ message: ex.message, icon: 'error' });
      unblock();
    }
  });
};

const putOnMarketplace = async () => {
  const marketplaceElements = $('.js-put-on-marketplace');
  if (!marketplaceElements.length) {
    return;
  }

  marketplaceElements.on('click', async (e) => {
    checkMetamask(e);

    const itemNetwork = marketplaceElements.data('network');
    if (window.selectedChain !== itemNetwork) {
      showOverlay(`Wrong network. Please switch your network to ${itemNetwork === 'CHZ' ? 'Chiliz ($CHZ)' : 'Avalanche ($AVAX)'}`, false);
      return;
    }

    Swal.fire({
      title: _t('What is the price?'),
      input: 'number',
      inputValidator: result => !result && _t('You need to enter value'),
      inputAttributes: {
        autocapitalize: 'off',
      },
      showCancelButton: true,
      confirmButtonText: _t('List'),
      showLoaderOnConfirm: true,
      preConfirm: async (value) => {
        const price = web3.utils.toWei(value, 'ether');
        const contract = getContract();
        const currentPrice = await contract.methods.calculatePrice().call();

        console.log(price, currentPrice);

        if (!parseInt(price)) {
          showAlert({
            message: _t('Please check price'),
            icon: 'error',
          });
        } else if (parseInt(price) < parseInt(currentPrice)) {
          Swal.fire({
            title: 'Warning!',
            html: `<p class="text-left">${_t(`You are trying to sell less than current mint price and it may be much more valuable with the upcoming updates. Are you sure to sell for ${value}`)}</p>`,
            showCancelButton: true,
            confirmButtonText: 'Sure!',
            showLoaderOnConfirm: true,
            allowOutsideClick: () => !Swal.isLoading(),
          }).then(async (result) => {
            if (result.isConfirmed) {
              const accounts = await web3.eth.getAccounts();

              try {
                showAlert({
                  title: 'In Progress',
                  message: 'Please wait while your transaction is in progress.',
                  icon: 'wait',
                });

                const response = await contract.methods.putOnMarketplace($(e.currentTarget).data('token-id'), price).send(0, {
                  from: accounts[0],
                  maxPriorityFeePerGas: null,
                  maxFeePerGas: null,
                });
                await refreshAndReload($(e.currentTarget).data('token-id'));
                window.location.reload(1);
              } catch (ex) {
                showAlert({ message: ex.message, icon: 'error' });
                unblock();
              }
            }
          });
        } else {
          const accounts = await web3.eth.getAccounts();
          const contract = getContract();

          try {
            showAlert({
              title: 'In Progress',
              message: 'Please wait while your transaction is in progress. You will be redirected to My Wallet page when the transaction succeeds.',
              icon: 'wait',
            });

            const response = await contract.methods.putOnMarketplace($(e.currentTarget).data('token-id'), price).send(0, {
              from: accounts[0],
              maxPriorityFeePerGas: null,
              maxFeePerGas: null,
            });
            await refreshAndReload($(e.currentTarget).data('token-id'));
            window.location.reload(1);
          } catch (ex) {
            showAlert({ message: ex.message, icon: 'error' });
            unblock();
          }
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      if (result.isConfirmed) {
        if (result.value && result.value.status) {
          Swal.fire(
            _t('Success!'),
            'Send',
            'success',
          );
        }
      }

      await refreshAndReload($(e.currentTarget).data('token-id'));
      window.location.reload(1);
    });
  });
};


if ($('.js-reload-my-training').length) {
  (async () => {
    const widgetId = $('.js-reload-my-training').data('cms_design_widget_id');
    const token = getToken();

    $.post(`/ajax/widget/render?cms_design_widget_id=${widgetId}&is_ajax=1&page_no=${window.currentPageNo}`, `token=${token}&chainId=${window.selectedChain === 'CHZ' ? window.chainIdChz : window.chainId}`, (data) => {
      $(`.widget[data-design-widget-id="${widgetId}"]`).html(data);
      checkMyWalletBar();
      claimTokens();
      claimNfsgxTokens();
      retryClaimToken();
      retryClaimNfsgxToken();
      putOnMarketplace();
      removeFromMarketplace();
      buyFromMarketplace();
      stakeTokens();
      stakeNfsgxTokens();
      filters();
    });
  })();
}

const initTrainingCenter = async () => {
  if ($('.js-reload-my-pagms').length) {
    if (!await checkMetamask()) {
      return;
    }

    await (async () => {
      const widgetId = $('.js-reload-my-pagms').data('cms_design_widget_id');
      const accounts = await window.web3.eth.getAccounts();
      const token = getToken();

      // block();
      $.post(`/ajax/widget/render?info_item_id=${window.itemId}&token=${token}&cms_design_widget_id=${widgetId}&is_ajax=1&page_no=${window.currentPageNo}`, `address=${accounts[0]}&chainId=${window.selectedChain === 'CHZ' ? window.chainIdChz : window.chainId}`, (data) => {
        // unblock();
        $(`.widget[data-design-widget-id="${widgetId}"]`).html(data);
        checkMyWalletBar();
        retryClaimToken();
        retryClaimNfsgxToken();
        stakeTokens();
        stakeNfsgxTokens();
        // reloadMyTokens();
        // claimTokens();
      }).done(() => {
        // localDatetime();
      });
    })();
  }
};

const jerseyClaim = () => {
  $(document).on('click', '.jerseyClaim', async (e) => {
    const $that = $(e.currentTarget);
    block();

    if (!await checkMetamask()) {
      unblock();
      return;
    }

    if (!await login()) {
      unblock();
      return;
    }

    const msgData = {
      sessionKey: window.sessionKey,
      jerseyName: $that.data('name'),
    };

    $.post({
      url: '/api/game/jerseyClaim',
      headers: {
        token: window.token,
      },
      data: msgData,
      success: (data) => {
        unblock();
        if (data.success) {
          Swal.fire(
            _t('Congratulations!'),
            data.message,
            'success',
          ).then(() => {
            window.location.href = '/my-items';
          });
        } else {
          Swal.fire(
            _t('Error!'),
            data.message,
            'error',
          ).then(() => {
            document.location.reload(true);
          });
        }
      },
      error(xhr, status, error) {
        // handle error
      },
    });
  });
};

const logout = () => {
  $(document).on('click', '.js-logout', async () => {
    await logoutRequest();
    window.localStorage.removeItem('token');
    window.sessionStorage.removeItem('sessionKey');

    setTimeout(() => {
      window.location.href = '/login';
    }, 200);
  });
};

const getAddress = async () => {
  if (!await checkMetamask()) {
    return;
  }
  const accounts = await web3Client.eth.getAccounts();
  const address = accounts[0];
  return address;
};

const transferTrainingCenter = async () => {
  const transferElements = $('.js-transfer-training-center');
  if (!transferElements.length) {
    return;
  }

  transferElements.on('click', async (e) => {
    Swal.fire({
      input: 'text',
      html: `
        <h3 style="margin-top: 40px;margin-bottom: 80px;">${_t('Target Address?')}</h3>
        <p style="margin-top:30px">Transfer operation costs 1 $NFSG.</p>
      `,
      inputValidator: result => !result && _t('You need to enter value'),
      inputAttributes: {
        autocapitalize: 'off',
      },
      customClass: {
        cancelButton: 'order-1',
        confirmButton: 'order-2',
        denyButton: 'order-3',
      },
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonText: _t('Send'),
      showLoaderOnConfirm: true,
      preConfirm: async (to) => {
        if (!await login()) {
          return;
        }
        const id = $(e.currentTarget).data('id');

        const isValidAddress = web3Client.utils.isAddress(to);
        if (!isValidAddress) {
          showAlert({ message: _t('Please enter a valid address'), icon: 'error' });
        } else {
          to = window.web3Client.utils.toChecksumAddress(to);

          const msgData = {
            sessionKey: window.sessionKey,
            to,
            id,
          };

          $.post({
            url: '/api/training-center/transfer',
            headers: {
              token: window.token,
            },
            data: msgData,
            success: async (data) => {
              if (data.success) {
                await Swal.fire(
                  _t('Success!'),
                  data.message,
                  'success',
                );

                document.location.reload(true);
              } else {
                Swal.fire(
                  _t('Failed!'),
                  data.message,
                  'error',
                );
              }
            },
            error(xhr, status, error) {
              // handle error
            },
          });
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.isConfirmed) {
        if (result.value && result.value.status) {
          Swal.fire(
            _t('Success!'),
            'Send',
            'success',
          );
        }
      }
    });
  });
};

const transferNftYoungPlayer = async () => {
  const transferElements = $('.js-transfer-young-player');
  if (!transferElements.length) {
    return;
  }

  transferElements.on('click', async (e) => {
    Swal.fire({
      input: 'text',
      html: `
        <h3 style="margin-top: 40px;margin-bottom: 80px;">${_t('Target Address?')}</h3>
        <p style="margin-top:30px">Transfer operation costs 2 $NFSG.</p>
      `,
      inputValidator: result => !result && _t('You need to enter value'),
      inputAttributes: {
        autocapitalize: 'off',
      },
      customClass: {
        cancelButton: 'order-1',
        confirmButton: 'order-2',
        denyButton: 'order-3',
      },
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonText: _t('Send'),
      showLoaderOnConfirm: true,
      preConfirm: async (to) => {
        if (!await login()) {
          return;
        }
        const id = $(e.currentTarget).data('token-id');

        const isValidAddress = web3Client.utils.isAddress(to);
        if (!isValidAddress) {
          showAlert({ message: _t('Please enter a valid address'), icon: 'error' });
        } else {
          to = window.web3Client.utils.toChecksumAddress(to);
          const msgData = {
            sessionKey: window.sessionKey,
            to,
            id,
          };

          $.post({
            url: '/api/young-player/transfer',
            headers: {
              token: window.token,
            },
            data: msgData,
            success: async (data) => {
              if (data.success) {
                await Swal.fire(
                  _t('Success!'),
                  data.message,
                  'success',
                );

                document.location.reload(true);
              } else {
                Swal.fire(
                  _t('Failed!'),
                  data.message,
                  'error',
                );
              }
            },
            error(xhr, status, error) {
              // handle error
            },
          });
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.isConfirmed) {
        if (result.value && result.value.status) {
          Swal.fire(
            _t('Success!'),
            'Send',
            'success',
          );
        }
      }
    });
  });
};

const sellTrainingCenter = async () => {
  $(document).on('click', '.js-put-training-center-on-marketplace', async (e) => {
    const id = $(e.currentTarget).data('id');

    Swal.fire({
      html: `
        <h3 style="margin-top: 40px; margin-bottom: 60px">${_t('What is the price in $NFSG?')}</h3>
      `,
      input: 'number',
      inputValidator: result => !result && _t('You need to enter value'),
      inputAttributes: {
        autocapitalize: 'off',
      },
      customClass: {
        cancelButton: 'order-1',
        confirmButton: 'order-2',
        denyButton: 'order-3',
      },
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonText: _t('Send'),
      showLoaderOnConfirm: true,
      preConfirm: async (value) => {
        if (!await login()) {
          return;
        }

        if (value < 1) {
          showAlert({ message: _t('Minimum price is %s $NFSG').replace('%s', '1'), icon: 'error' });
        } else {
          const msgData = {
            sessionKey: window.sessionKey,
            id,
            price: value,
          };

          $.post({
            url: '/api/training-center/setPrice',
            headers: {
              token: window.token,
            },
            data: msgData,
            success: async (data) => {
              if (data.success) {
                await Swal.fire(
                  _t('Success!'),
                  data.message,
                  'success',
                );

                document.location.reload(true);
              } else {
                Swal.fire(
                  _t('Failed!'),
                  data.message,
                  'error',
                );
              }
            },
            error(xhr, status, error) {
              // handle error
            },
          });
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.isConfirmed) {
        if (result.value && result.value.status) {
          Swal.fire(
            _t('Success!'),
            'Send',
            'success',
          );
        }
      }
    });
  });
};

const sellYoungPlayer = async () => {
  $(document).on('click', '.js-put-on-marketplace-young-player', async (e) => {
    const id = $(e.currentTarget).data('token-id');

    Swal.fire({
      html: `
        <h3 style="margin-top: 40px; margin-bottom: 60px">${_t('What is the price in $NFSG?')}</h3>
      `,
      input: 'number',
      inputValidator: result => !result && _t('You need to enter value'),
      inputAttributes: {
        autocapitalize: 'off',
      },
      customClass: {
        cancelButton: 'order-1',
        confirmButton: 'order-2',
        denyButton: 'order-3',
      },
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonText: _t('Send'),
      showLoaderOnConfirm: true,
      preConfirm: async (value) => {
        if (!await login()) {
          return;
        }

        if (value < 1) {
          showAlert({ message: _t('Minimum price is %s $NFSG').replace('%s', '1'), icon: 'error' });
        } else {
          const msgData = {
            sessionKey: window.sessionKey,
            id,
            price: value,
          };

          $.post({
            url: '/api/young-player/setPrice',
            headers: {
              token: window.token,
            },
            data: msgData,
            success: async (data) => {
              if (data.success) {
                await Swal.fire(
                  _t('Success!'),
                  data.message,
                  'success',
                );

                document.location.reload(true);
              } else {
                Swal.fire(
                  _t('Failed!'),
                  data.message,
                  'error',
                );
              }
            },
            error(xhr, status, error) {
              // handle error
            },
          });
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.isConfirmed) {
        if (result.value && result.value.status) {
          Swal.fire(
            _t('Success!'),
            'Send',
            'success',
          );
        }
      }
    });
  });
};

const buyYoungPlayerFromMarketplace = async () => {
  $(document).on('click', '.js-buy-young-player-from-marketplace', async (e) => {
    const message = $(e.currentTarget).data('message');
    const id = $(e.currentTarget).data('token-id');
    const price = $(e.currentTarget).data('price');

    Swal.fire({
      title: 'Buy',
      html: `<p class="text-left" style="margin-top: 30px;">${_t(message)}</p>`,
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: _t('Buy!'),
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      if (result.isConfirmed) {
        if (!await login()) {
          return;
        }

        const msgData = {
          id,
          sessionKey: window.sessionKey,
          price,
        };

        $.post({
          url: '/api/young-player/buy',
          headers: {
            token: window.token,
          },
          data: msgData,
          success: (data) => {
            if (data.success) {
              Swal.fire(
                _t('Success!'),
                data.message,
                'success',
              );

              document.location.reload(true);
            } else {
              Swal.fire(
                _t('Error!'),
                data.message,
                'error',
              );
            }
          },
          error(xhr, status, error) {
            // handle error
          },
        });
      }
    });
  });
};

const buyTrainingCenterFromMarketplace = async () => {
  $(document).on('click', '.js-buy-training-center-from-marketplace', async (e) => {
    const message = $(e.currentTarget).data('message');
    const id = $(e.currentTarget).data('id');
    const price = $(e.currentTarget).data('price');

    Swal.fire({
      title: 'Buy',
      html: `<p class="text-left" style="margin-top: 30px;">${_t(message)}</p>`,
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: _t('Buy!'),
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      if (result.isConfirmed) {
        if (!await login()) {
          return;
        }

        const msgData = {
          id,
          sessionKey: window.sessionKey,
          price,
        };

        $.post({
          url: '/api/training-center/buy',
          headers: {
            token: window.token,
          },
          data: msgData,
          success: (data) => {
            if (data.success) {
              Swal.fire(
                _t('Success!'),
                data.message,
                'success',
              );

              document.location.reload(true);
            } else {
              Swal.fire(
                _t('Error!'),
                data.message,
                'error',
              );
            }
          },
          error(xhr, status, error) {
            // handle error
          },
        });
      }
    });
  });
};

const removeTrainingCenterFromMarketplace = async () => {
  // if (!marketplaceElements.length) {
  //   return;
  // }

  $(document).on('click', '.js-remove-training-center-from-marketplace', async (e) => {
    const id = $(e.currentTarget).data('id');

    if (!await login()) {
      return;
    }

    Swal.fire({
      title: _t('Training Center Price'),
      html: _t(`Are you sure you want to remove your Training Center #${id} from Marketplace`),
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: _t('Remove'),
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      if (result.isConfirmed) {
        const msgData = {
          id,
          sessionKey: window.sessionKey,
        };
        $.post({
          url: '/api/training-center/cancelSale',
          headers: {
            token: window.token,
          },
          data: msgData,
          success: async (data) => {
            if (data.success) {
              await Swal.fire(
                _t('Success!'),
                data.message,
                'success',
              );

              document.location.reload(true);
            } else {
              Swal.fire(
                _t('Failed!'),
                data.message,
                'error',
              );
            }
          },
          error(xhr, status, error) {
            // handle error
          },
        });
      }
    });
  });
};

const removeYoungPlayerFromMarketplace = async () => {
  // if (!marketplaceElements.length) {
  //   return;
  // }

  $(document).on('click', '.js-remove-young-player-from-marketplace', async (e) => {
    const id = $(e.currentTarget).data('token-id');

    if (!await login()) {
      return;
    }

    Swal.fire({
      title: _t('Young Player'),
      html: _t(`Are you sure you want to remove your Young Player #${id} from Marketplace`),
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: _t('Remove'),
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      if (result.isConfirmed) {
        const msgData = {
          id,
          sessionKey: window.sessionKey,
        };

        $.post({
          url: '/api/young-player/cancelSale',
          headers: {
            token: window.token,
          },
          data: msgData,
          success: async (data) => {
            if (data.success) {
              await Swal.fire(
                _t('Success!'),
                data.message,
                'success',
              );

              document.location.reload(true);
            } else {
              Swal.fire(
                _t('Failed!'),
                data.message,
                'error',
              );
            }
          },
          error(xhr, status, error) {
            // handle error
          },
        });
      }
    });
  });
};

const transferGear = async () => {
  const transferElements = $('.js-transfer-gear');
  if (!transferElements.length) {
    return;
  }

  transferElements.on('click', async (e) => {
    Swal.fire({
      input: 'text',
      html: `
        <h3 style="margin-top: 40px;margin-bottom: 80px;">${_t('Target Address?')}</h3>
      `,
      inputValidator: result => !result && _t('You need to enter value'),
      inputAttributes: {
        autocapitalize: 'off',
      },
      customClass: {
        cancelButton: 'order-1',
        confirmButton: 'order-2',
        denyButton: 'order-3',
      },
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonText: _t('Send'),
      showLoaderOnConfirm: true,
      preConfirm: async (to) => {
        if (!await login()) {
          return;
        }
        const id = $(e.currentTarget).data('id');

        const isValidAddress = web3Client.utils.isAddress(to);
        if (!isValidAddress) {
          showAlert({ message: _t('Please enter a valid address'), icon: 'error' });
        } else {
          await checkMetamask();
          const accounts = await window.web3.eth.getAccounts();
          const response = await fetch('/api/wallet/nonce', {
            headers: {
              'Content-Type': 'application/json',
            },
            method: 'post',
            authorization: true,
            body: JSON.stringify({
              address: accounts[0],
            }),
          }).then(res => res.json());
          const { personal } = window.web3.eth;
          const signature = await personal.sign(web3Client.utils.toHex(`Transfer Gear #${id} From ${accounts[0]} To ${to}`), accounts[0]);

          const msgData = {
            sessionKey: window.sessionKey,
            to: window.web3Client.utils.toChecksumAddress(to),
            id,
            signature,
            nonce: response.nonce,
          };

          $.post({
            url: '/api/gear/transfer',
            headers: {
              token: window.token,
            },
            data: msgData,
            success: async (data) => {
              if (data.success) {
                await Swal.fire(
                  _t('Success!'),
                  data.message,
                  'success',
                );

                document.location.reload(true);
              } else {
                Swal.fire(
                  _t('Failed!'),
                  data.message,
                  'error',
                );
              }
            },
            error(xhr, status, error) {
              // handle error
            },
          });
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.isConfirmed) {
        if (result.value && result.value.status) {
          Swal.fire(
            _t('Success!'),
            'Send',
            'success',
          );
        }
      }
    });
  });
};

const sellGear = async () => {
  $(document).on('click', '.js-put-gear-on-marketplace', async (e) => {
    const id = $(e.currentTarget).data('id');

    Swal.fire({
      html: `
        <h3 style="margin-top: 40px; margin-bottom: 60px">${_t('What is the price in $NFSG?')}</h3>
      `,
      input: 'number',
      inputValidator: result => !result && _t('You need to enter value'),
      inputAttributes: {
        autocapitalize: 'off',
      },
      customClass: {
        cancelButton: 'order-1',
        confirmButton: 'order-2',
        denyButton: 'order-3',
      },
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonText: _t('Send'),
      showLoaderOnConfirm: true,
      preConfirm: async (value) => {
        if (!await login()) {
          return;
        }

        if (value < 1) {
          showAlert({ message: _t('Minimum price is %s $NFSG').replace('%s', '1'), icon: 'error' });
        } else {
          const msgData = {
            sessionKey: window.sessionKey,
            id,
            price: value,
          };

          $.post({
            url: '/api/gear/setPrice',
            headers: {
              token: window.token,
            },
            data: msgData,
            success: async (data) => {
              if (data.success) {
                await Swal.fire(
                  _t('Success!'),
                  data.message,
                  'success',
                );

                document.location.reload(true);
              } else {
                Swal.fire(
                  _t('Failed!'),
                  data.message,
                  'error',
                );
              }
            },
            error(xhr, status, error) {
              // handle error
            },
          });
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.isConfirmed) {
        if (result.value && result.value.status) {
          Swal.fire(
            _t('Success!'),
            'Send',
            'success',
          );
        }
      }
    });
  });
};

const buyGearFromMarketplace = async () => {
  $(document).on('click', '.js-buy-gear-from-marketplace', async (e) => {
    const message = $(e.currentTarget).data('message');
    const id = $(e.currentTarget).data('id');
    const price = $(e.currentTarget).data('price');

    Swal.fire({
      title: 'Buy',
      html: `<p class="text-left" style="margin-top: 30px;">${_t(message)}</p>`,
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: _t('Buy!'),
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      if (result.isConfirmed) {
        if (!await login()) {
          return;
        }

        const msgData = {
          id,
          sessionKey: window.sessionKey,
          price,
        };

        $.post({
          url: '/api/gear/buy',
          headers: {
            token: window.token,
          },
          data: msgData,
          success: (data) => {
            if (data.success) {
              Swal.fire(
                _t('Success!'),
                data.message,
                'success',
              );

              document.location.reload(true);
            } else {
              Swal.fire(
                _t('Error!'),
                data.message,
                'error',
              );
            }
          },
          error(xhr, status, error) {
            // handle error
          },
        });
      }
    });
  });
};

const removeGearFromMarketplace = async () => {
  // if (!marketplaceElements.length) {
  //   return;
  // }

  $(document).on('click', '.js-remove-gear-from-marketplace', async (e) => {
    const id = $(e.currentTarget).data('id');

    if (!await login()) {
      return;
    }

    Swal.fire({
      title: _t('Gear Price'),
      html: _t(`Are you sure you want to remove your Gear #${id} from Marketplace`),
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: _t('Remove'),
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      if (result.isConfirmed) {
        const msgData = {
          id,
          sessionKey: window.sessionKey,
        };

        $.post({
          url: '/api/gear/cancelSale',
          headers: {
            token: window.token,
          },
          data: msgData,
          success: async (data) => {
            if (data.success) {
              await Swal.fire(
                _t('Success!'),
                data.message,
                'success',
              );

              document.location.reload(true);
            } else {
              Swal.fire(
                _t('Failed!'),
                data.message,
                'error',
              );
            }
          },
          error(xhr, status, error) {
            // handle error
          },
        });
      }
    });
  });
};

const transferShoe = async () => {
  const transferElements = $('.js-transfer-shoe');
  if (!transferElements.length) {
    return;
  }

  transferElements.on('click', async (e) => {
    Swal.fire({
      input: 'text',
      html: `
        <h3 style="margin-top: 40px;margin-bottom: 80px;">${_t('Target Address?')}</h3>
      `,
      inputValidator: result => !result && _t('You need to enter value'),
      inputAttributes: {
        autocapitalize: 'off',
      },
      customClass: {
        cancelButton: 'order-1',
        confirmButton: 'order-2',
        denyButton: 'order-3',
      },
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonText: _t('Send'),
      showLoaderOnConfirm: true,
      preConfirm: async (to) => {
        if (!await login()) {
          return;
        }
        const id = $(e.currentTarget).data('id');

        const isValidAddress = web3Client.utils.isAddress(to);
        if (!isValidAddress) {
          showAlert({ message: _t('Please enter a valid address'), icon: 'error' });
        } else {
          await checkMetamask();
          const accounts = await window.web3.eth.getAccounts();
          const response = await fetch('/api/wallet/nonce', {
            headers: {
              'Content-Type': 'application/json',
            },
            method: 'post',
            authorization: true,
            body: JSON.stringify({
              address: accounts[0],
            }),
          }).then(res => res.json());
          const { personal } = window.web3.eth;
          const signature = await personal.sign(web3Client.utils.toHex(`Transfer Shoe #${id} From ${accounts[0]} To ${to}`), accounts[0]);
          const msgData = {
            sessionKey: window.sessionKey,
            to: window.web3Client.utils.toChecksumAddress(to),
            id,
            nonce: response.nonce,
            signature,
          };

          $.post({
            url: '/api/shoe/transfer',
            headers: {
              token: window.token,
            },
            data: msgData,
            success: async (data) => {
              if (data.success) {
                await Swal.fire(
                  _t('Success!'),
                  data.message,
                  'success',
                );

                document.location.reload(true);
              } else {
                Swal.fire(
                  _t('Failed!'),
                  data.message,
                  'error',
                );
              }
            },
            error(xhr, status, error) {
              // handle error
            },
          });
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.isConfirmed) {
        if (result.value && result.value.status) {
          Swal.fire(
            _t('Success!'),
            'Send',
            'success',
          );
        }
      }
    });
  });
};

const sellShoe = async () => {
  $(document).on('click', '.js-put-shoe-on-marketplace', async (e) => {
    const id = $(e.currentTarget).data('id');

    Swal.fire({
      html: `
        <h3 style="margin-top: 40px; margin-bottom: 60px">${_t('What is the price in $NFSG?')}</h3>
      `,
      input: 'number',
      inputValidator: result => !result && _t('You need to enter value'),
      inputAttributes: {
        autocapitalize: 'off',
      },
      customClass: {
        cancelButton: 'order-1',
        confirmButton: 'order-2',
        denyButton: 'order-3',
      },
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonText: _t('Send'),
      showLoaderOnConfirm: true,
      preConfirm: async (value) => {
        if (!await login()) {
          return;
        }

        if (value < 1) {
          showAlert({ message: _t('Minimum price is %s $NFSG').replace('%s', '1'), icon: 'error' });
        } else {
          const msgData = {
            sessionKey: window.sessionKey,
            id,
            price: value,
          };

          $.post({
            url: '/api/shoe/setPrice',
            headers: {
              token: window.token,
            },
            data: msgData,
            success: async (data) => {
              if (data.success) {
                await Swal.fire(
                  _t('Success!'),
                  data.message,
                  'success',
                );

                document.location.reload(true);
              } else {
                Swal.fire(
                  _t('Failed!'),
                  data.message,
                  'error',
                );
              }
            },
            error(xhr, status, error) {
              // handle error
            },
          });
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.isConfirmed) {
        if (result.value && result.value.status) {
          Swal.fire(
            _t('Success!'),
            'Send',
            'success',
          );
        }
      }
    });
  });
};

const buyShoeFromMarketplace = async () => {
  $(document).on('click', '.js-buy-shoe-from-marketplace', async (e) => {
    const message = $(e.currentTarget).data('message');
    const id = $(e.currentTarget).data('id');
    const price = $(e.currentTarget).data('price');

    Swal.fire({
      title: 'Buy',
      html: `<p class="text-left" style="margin-top: 30px;">${_t(message)}</p>`,
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: _t('Buy!'),
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      if (result.isConfirmed) {
        if (!await login()) {
          return;
        }

        const msgData = {
          id,
          sessionKey: window.sessionKey,
          price,
        };

        $.post({
          url: '/api/shoe/buy',
          headers: {
            token: window.token,
          },
          data: msgData,
          success: (data) => {
            if (data.success) {
              Swal.fire(
                _t('Success!'),
                data.message,
                'success',
              );

              document.location.reload(true);
            } else {
              Swal.fire(
                _t('Error!'),
                data.message,
                'error',
              );
            }
          },
          error(xhr, status, error) {
            // handle error
          },
        });
      }
    });
  });
};

const removeShoeFromMarketplace = async () => {
  // if (!marketplaceElements.length) {
  //   return;
  // }

  $(document).on('click', '.js-remove-shoe-from-marketplace', async (e) => {
    const id = $(e.currentTarget).data('id');

    if (!await login()) {
      return;
    }

    Swal.fire({
      title: _t('Shoe Price'),
      html: _t(`Are you sure you want to remove your Gear #${id} from Marketplace`),
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: _t('Remove'),
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      if (result.isConfirmed) {
        const msgData = {
          id,
          sessionKey: window.sessionKey,
        };

        $.post({
          url: '/api/shoe/cancelSale',
          headers: {
            token: window.token,
          },
          data: msgData,
          success: async (data) => {
            if (data.success) {
              await Swal.fire(
                _t('Success!'),
                data.message,
                'success',
              );

              document.location.reload(true);
            } else {
              Swal.fire(
                _t('Failed!'),
                data.message,
                'error',
              );
            }
          },
          error(xhr, status, error) {
            // handle error
          },
        });
      }
    });
  });
};

const sellBox = async () => {
  $(document).on('click', '.js-put-nft-box-on-marketplace', async (e) => {
    const jerseyId = $(e.currentTarget).data('id');

    Swal.fire({
      html: `
        <h3 style="margin-top: 40px; margin-bottom: 60px">${_t('What is the price in $NFSG?')}</h3>
      `,
      input: 'number',
      inputValidator: result => !result && _t('You need to enter value'),
      inputAttributes: {
        autocapitalize: 'off',
      },
      customClass: {
        cancelButton: 'order-1',
        confirmButton: 'order-2',
        denyButton: 'order-3',
      },
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonText: _t('Send'),
      showLoaderOnConfirm: true,
      preConfirm: async (value) => {
        if (!await login()) {
          return;
        }

        if (value < 1) {
          showAlert({ message: _t('Minimum price is %s $NFSG').replace('%s', '1'), icon: 'error' });
        } else {
          const msgData = {
            sessionKey: window.sessionKey,
            boxId: jerseyId,
            price: value,
          };

          $.post({
            url: '/api/box/setPrice',
            headers: {
              token: window.token,
            },
            data: msgData,
            success: async (data) => {
              if (data.success) {
                await Swal.fire(
                  _t('Success!'),
                  data.message,
                  'success',
                );

                document.location.reload(true);
              } else {
                Swal.fire(
                  _t('Failed!'),
                  data.message,
                  'error',
                );
              }
            },
            error(xhr, status, error) {
              // handle error
            },
          });
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.isConfirmed) {
        if (result.value && result.value.status) {
          Swal.fire(
            _t('Success!'),
            'Send',
            'success',
          );
        }
      }
    });
  });
};

const sellJersey = async () => {
  $(document).on('click', '.js-put-box-on-marketplace', async (e) => {
    const jerseyId = $(e.currentTarget).data('id');

    Swal.fire({
      html: `
        <h3 style="margin-top: 40px; margin-bottom: 60px">${_t('What is the price in $NFSG?')}</h3>
      `,
      input: 'number',
      inputValidator: result => !result && _t('You need to enter value'),
      inputAttributes: {
        autocapitalize: 'off',
      },
      customClass: {
        cancelButton: 'order-1',
        confirmButton: 'order-2',
        denyButton: 'order-3',
      },
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonText: _t('Send'),
      showLoaderOnConfirm: true,
      preConfirm: async (value) => {
        if (!await login()) {
          return;
        }

        if (value < 1) {
          showAlert({ message: _t('Minimum price is %s $NFSG').replace('%s', '1'), icon: 'error' });
        } else {
          const msgData = {
            sessionKey: window.sessionKey,
            jerseyId,
            price: value,
          };

          $.post({
            url: '/api/jersey/setPrice',
            headers: {
              token: window.token,
            },
            data: msgData,
            success: async (data) => {
              if (data.success) {
                await Swal.fire(
                  _t('Success!'),
                  data.message,
                  'success',
                );

                document.location.reload(true);
              } else {
                Swal.fire(
                  _t('Failed!'),
                  data.message,
                  'error',
                );
              }
            },
            error(xhr, status, error) {
              // handle error
            },
          });
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.isConfirmed) {
        if (result.value && result.value.status) {
          Swal.fire(
            _t('Success!'),
            'Send',
            'success',
          );
        }
      }
    });
  });
};

const removeBoxFromMarketplace = async () => {
  // if (!marketplaceElements.length) {
  //   return;
  // }

  $(document).on('click', '.js-remove-nft-box-from-marketplace', async (e) => {
    const jerseyId = $(e.currentTarget).data('id');

    if (!await login()) {
      return;
    }

    Swal.fire({
      title: _t('Sport Bag Price'),
      html: `
        <p style="margin-top: 40px; margin-bottom: 40px; padding: 30px 20px;">${_t(`Are you sure you want to remove your Sport Bag #${jerseyId} from Marketplace`)}</p>
      `,
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: _t('Remove'),
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      if (result.isConfirmed) {
        const msgData = {
          boxId: jerseyId,
          sessionKey: window.sessionKey,
        };

        $.post({
          url: '/api/box/cancelSale',
          headers: {
            token: window.token,
          },
          data: msgData,
          success: async (data) => {
            if (data.success) {
              await Swal.fire(
                _t('Success!'),
                data.message,
                'success',
              );

              document.location.reload(true);
            } else {
              Swal.fire(
                _t('Failed!'),
                data.message,
                'error',
              );
            }
          },
          error(xhr, status, error) {
            // handle error
          },
        });
      }
    });
  });
};

const removeJerseyFromMarketplace = async () => {
  // if (!marketplaceElements.length) {
  //   return;
  // }

  $(document).on('click', '.js-remove-box-from-marketplace', async (e) => {
    const jerseyId = $(e.currentTarget).data('id');

    if (!await login()) {
      return;
    }

    Swal.fire({
      title: _t('Jersey Price'),
      html: `
        <p style="margin-top: 40px; margin-bottom: 40px; padding: 30px 20px;">${_t(`Are you sure you want to remove your Jersey #${jerseyId} from Marketplace`)}</p>
      `,
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: _t('Remove'),
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      if (result.isConfirmed) {
        const msgData = {
          jerseyId,
          sessionKey: window.sessionKey,
        };

        $.post({
          url: '/api/jersey/cancelSale',
          headers: {
            token: window.token,
          },
          data: msgData,
          success: async (data) => {
            if (data.success) {
              await Swal.fire(
                _t('Success!'),
                data.message,
                'success',
              );

              document.location.reload(true);
            } else {
              Swal.fire(
                _t('Failed!'),
                data.message,
                'error',
              );
            }
          },
          error(xhr, status, error) {
            // handle error
          },
        });
      }
    });
  });
};

const tranferJersey = async () => {
  $(document).on('click', '.js-transfer-jersey', async (e) => {
    const jerseyId = $(e.currentTarget).data('id');
    Swal.fire({
      html: `
        <h3 style="margin-top: 40px;margin-bottom: 80px;">${_t('Target Address?')}</h3>
      `,
      input: 'text',
      inputValidator: result => !result && _t('You need to enter value'),
      inputAttributes: {
        autocapitalize: 'off',
      },
      customClass: {
        cancelButton: 'order-1',
        confirmButton: 'order-2',
        denyButton: 'order-3',
      },
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonText: _t('Send'),
      showLoaderOnConfirm: true,
      preConfirm: async (to) => {
        if (!await login()) {
          return;
        }

        const isValidAddress = web3Client.utils.isAddress(to);
        if (!isValidAddress) {
          showAlert({ message: _t('Please enter a valid address'), icon: 'error' });
        } else {
          to = window.web3Client.utils.toChecksumAddress(to);

          const accounts = await web3Client.eth.getAccounts();

          const response = await fetch('/api/wallet/nonce', {
            headers: {
              'Content-Type': 'application/json',
            },
            method: 'post',
            authorization: true,
            body: JSON.stringify({
              address: accounts[0],
            }),
          }).then(res => res.json());
          const personal = new Web3EthPersonal(ethereum);

          try {
            const signature = await personal.sign(web3Client.utils.toHex(`Transfer Jersey #${jerseyId} From ${accounts[0]} To ${to}`), accounts[0]);

            const msgData = {
              sessionKey: window.sessionKey,
              to,
              jerseyId,
              nonce: response.nonce,
              signature,
            };

            $.post({
              url: '/api/jersey/transfer',
              headers: {
                token: window.token,
              },
              data: msgData,
              success: async (data) => {
                if (data.success) {
                  await Swal.fire(
                    _t('Success!'),
                    data.message,
                    'success',
                  );

                  document.location.reload(true);
                } else {
                  Swal.fire(
                    _t('Failed!'),
                    data.message,
                    'error',
                  );
                }
              },
              error(xhr, status, error) {
                // handle error
              },
            });
          } catch (error) {
            showAlert({ message: error.message, icon: 'error' });
          }
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.isConfirmed) {
        if (result.value && result.value.status) {
          Swal.fire(
            _t('Success!'),
            'Send',
            'success',
          );
        }
      }
    });
  });
};

const initBuyJersey = async () => {
  $(document).on('click', '.js-buy-jersey', async (e) => {
    const message = $(e.currentTarget).data('message');
    const jerseyId = $(e.currentTarget).data('id');
    const price = $(e.currentTarget).data('price');

    Swal.fire({
      title: 'Buy Jersey',
      html: `<p class="text-left" style="margin-top: 30px;">${_t(message)}</p>`,
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: _t('Buy!'),
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      if (result.isConfirmed) {
        if (!await login()) {
          return;
        }

        const msgData = {
          jerseyId,
          sessionKey: window.sessionKey,
          price,
        };

        $.post({
          url: '/api/jersey/buy',
          headers: {
            token: window.token,
          },
          data: msgData,
          success: (data) => {
            if (data.success) {
              Swal.fire(
                _t('Success!'),
                data.message,
                'success',
              );

              document.location.reload(true);
            } else {
              Swal.fire(
                _t('Error!'),
                data.message,
                'error',
              );
            }
          },
          error(xhr, status, error) {
            // handle error
          },
        });
      }
    });
  });
};

const initBuyBox = async () => {
  $(document).on('click', '.js-buy-box', async (e) => {
    const message = $(e.currentTarget).data('message');
    const jerseyId = $(e.currentTarget).data('id');
    const price = $(e.currentTarget).data('price');

    Swal.fire({
      title: 'Buy Sport Bag',
      html: `<p class="text-left" style="margin-top: 30px;">${_t(message)}</p>`,
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: _t('Buy!'),
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      if (result.isConfirmed) {
        if (!await login()) {
          return;
        }

        const msgData = {
          boxId: jerseyId,
          sessionKey: window.sessionKey,
          price,
        };

        $.post({
          url: '/api/box/buy',
          headers: {
            token: window.token,
          },
          data: msgData,
          success: (data) => {
            if (data.success) {
              Swal.fire(
                _t('Success!'),
                data.message,
                'success',
              );

              document.location.reload(true);
            } else {
              Swal.fire(
                _t('Error!'),
                data.message,
                'error',
              );
            }
          },
          error(xhr, status, error) {
            // handle error
          },
        });
      }
    });
  });
};

const openBox = async () => {
  const marketplaceElements = $('.js-open-box');
  if (!marketplaceElements.length) {
    return;
  }

  marketplaceElements.on('click', async function (e) {
    const boxId = $(this).data('id');
    const message = $(this).data('message');

    Swal.fire({
      title: _t('Open Box'),
      html: `<p class="text-left" style="color: red; margin-top: 30px;">${_t(`Are you sure you want to open your Box #${boxId}!`)}</p>`,
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: _t('Open!'),
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      if (result.isConfirmed) {
        if (!await checkMetamask()) {
          return;
        }

        if (!await login()) {
          return;
        }

        const msgData = {
          sessionKey: window.sessionKey,
          boxId,
        };

        $.post({
          url: '/api/box/open',
          headers: {
            token: window.token,
          },
          data: msgData,
          success: (data) => {
            if (data.success) {
              Swal.fire(
                _t('Success!'),
                data.message,
                'success',
              );

              document.location.href += '?cache_refresh=1';
            } else {
              Swal.fire(
                _t('Error!'),
                data.message,
                'error',
              );
            }
          },
          error(xhr, status, error) {
            // handle error
          },
        });
      }
    });
  });
};

const claimOneBoxDrop = async () => {
  const marketplaceElements = $('.js-claim-one-boxdrop');
  if (!marketplaceElements.length) {
    return;
  }

  marketplaceElements.on('click', async function (e) {
    const avaxtarId = $(this).data('id');
    const nextBoxCount = $(this).data('next-id');
    const message = $(this).data('message');

    Swal.fire({
      title: 'Claim One BoxDrop',
      html: `<p class="text-left" style="margin-top: 30px;">${_t('This process can not be reverted and may reduce the market value of this nft. Please read <a class="boxdrop" target="_blank" href="/boxdrop"><u>here</u></a> carefully and be sure what you are doing!')}</p>`,
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: _t('Claim!'),
      showLoaderOnConfirm: true,
      customClass: {
        cancelButton: 'order-1',
        confirmButton: 'order-2',
        denyButton: 'order-3',
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      if (result.isConfirmed) {
        if (!await checkMetamask()) {
          return;
        }

        if (!await login()) {
          return;
        }

        const msgData = {
          sessionKey: window.sessionKey,
          id: avaxtarId,
          claimedBoxNumber: nextBoxCount,
        };

        const accounts = await window.web3.eth.getAccounts();

        $.post({
          url: '/api/box/claim',
          headers: {
            token: window.token,
          },
          data: msgData,
          success: (data) => {
            if (data.success) {
              Swal.fire(
                _t('Success!'),
                data.message,
                'success',
              );

              window.location = `/browse?t=items&f[data.type]=Sports%20Bags&address=${accounts[0]}&cache_refresh=1`;
            } else {
              Swal.fire(
                _t('Error!'),
                data.message,
                'error',
              );
            }
          },
          error(xhr, status, error) {
            // handle error
          },
        });
      }
    });
  });
};


const getOwnerOf = async () => {
  const ownerElements = $('.owner-of');
  if (!ownerElements.length) {
    return;
  }

  if (!await checkMetamask()) {
    return;
  }

  try {
    const accounts = await web3Client.eth.getAccounts();

    const contract = getContract();

    $(ownerElements).each(async function () {
      const owner = await contract.methods.ownerOf($(this).data('token-id')).call();
      if (!owner) {
        return;
      }

      const details = await contract.methods.Bazaar($(this).data('token-id')).call();
      const onSale = details.state === '1';
      if (owner.toLowerCase() === accounts[0].toLowerCase()) {
        $(this).closest('.js-card').find('.buy').text('This is yours')
          .off('click');
        $('.js-owner-only').show();
        $('.js-buy-from-marketplace').show();
        $('.js-withdraw-bid').hide();
        $('.js-box-information').show();
        $('.js-transfer').show();
        $('.js-transfer-gen2').show();
        $('.js-transfer-pagm').show();
        if (onSale) {
          $('.js-remove-from-marketplace').show();
        } else {
          $('.js-put-on-marketplace').show();
        }
      }

      $(this).text(owner);

      if (onSale) {
        $('.js-buy-avaxtar').text(`Buy for ${(details.price / 1000000000000000000).toFixed(2)} $AVAX`);
        $(this).closest('.js-card').find('.on-sale').show();
        $(this).closest('.js-card').find('.price').text(`Price : ${details.price / 1000000000000000000}` + ' AVAX')
          .css({
            marginBottom: '28px',
            fontSize: '28px',
          });
        if (owner.toLowerCase() !== accounts[0].toLowerCase()) {
          $('.js-buy-avaxtar').show();
        }
        $('.js-price-avaxtar').text(`${details.price / 1000000000000000000} AVAX`);
      } else {
        $(this).closest('.js-card').find('.not-for-sale').show();
      }
    });
  } catch (exp) {
    console.log(exp);
    // Nothing
  }
};

const joinCup = async () => {
  const transferElements = $('.js-join-cup');
  if (!transferElements.length) {
    return;
  }


  transferElements.on('click', async (e) => {
    const message = $(e.currentTarget).data('message');
    const cupName = $(e.currentTarget).data('name');

    Swal.fire({
      title: `<p class="text-left" style="margin-top: 30px;">${_t(cupName)} Cup</p>`,
      html: `<p class="text-left" style="margin-top: 30px;">${_t(message)}</p>`,
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: _t('Join!'),
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
      inputAttributes: {
        autocapitalize: 'off',
      },
      customClass: {
        cancelButton: 'order-1',
        confirmButton: 'order-2',
        denyButton: 'order-3',
      },
      preConfirm: async (to) => {
        const cupId = $(e.currentTarget).data('cup-id');

        const token = getToken();

        const msgData = {
          token,
          cupId,
        };

        $.post({
          url: '/api/cup/joinCup',
          headers: {
            token: window.token,
          },
          data: msgData,
          success: async (data) => {
            if (data.success) {
              await Swal.fire(
                _t('Success!'),
                data.message,
                'success',
              );

              document.location.reload(true);
            } else {
              Swal.fire(
                _t('Failed!'),
                data.message,
                'error',
              );
            }
          },
          error(xhr, status, error) {
            // handle error
          },
        });
      },
    }).then((result) => {
      if (result.isConfirmed) {
        if (result.value && result.value.status) {
          Swal.fire(
            _t('Success!'),
            'Send',
            'success',
          );
        }
      }
    });
  });
};

const initLogin = async () => {
  const $target = $('.js-login-page');
  if (!$target.length) {
    return;
  }

  const $loginForm = $('.js-login-form');
  const page = $loginForm.data('page');
  let address = '';

  if (page === 'verify-email') {
    if (!await login()) {
      return;
    }
    const accounts = await web3Client.eth.getAccounts();
    [address] = accounts;
    $('.js-wallet-address').val(address);
  }

  function getEmailDomain(email) {
    return email.substring(email.lastIndexOf('@') + 1);
  }

  function getEmailProviderLoginURL(domain) {
    const emailProviders = {
      'gmail.com': 'https://mail.google.com/',
      'yahoo.com': 'https://login.yahoo.com/',
      'yahoo.com.tr': 'https://login.yahoo.com/',
      'outlook.com': 'https://login.live.com/',
      'hotmail.com': 'https://login.live.com/',
      'hotmail.com.tr': 'https://login.live.com/',
      'aol.com': 'https://login.aol.com/',
      'protonmail.com': 'https://mail.protonmail.com/login',
      'yandex.com': 'https://mail.yandex.com/',
      'yandex.ru': 'https://mail.yandex.ru/',
      // Add more email providers if needed
    };

    return emailProviders[domain] || false;
  }

  let loginURL = '';

  $loginForm.on('submit', async (e) => {
    e.preventDefault();

    if (!$loginForm.valid()) {
      return false;
    }

    const email = $loginForm.find('[name="email"]').val();
    const domain = getEmailDomain(email);
    loginURL = getEmailProviderLoginURL(domain);

    const { success, message } = await getVerifyCode({
      data: {
        email,
        sessionKey: window.sessionKey,
        address,
      },
    });

    if (success) {
      verify();
    } else {
      Swal.fire(
        'Failed!',
        message,
        'error',
      ).then(() => {
        $('[name="email"]').val('');
        $('[name="email"]').focus();
      });
    }
  });

  function verify() {
    const loginText = $('#login-text').val();
    Swal.fire({
      html: `
          <div style="margin-top: 40px; margin-bottom: 20px">${loginText}</div>
        `,
      showCancelButton: false,
    });
  }

  $(document).on('click', '.js-login-metamask', async (e) => {
    // const $that = $(e.currentTarget);
    // block();
    // await checkMetamask();
    await login();
    // unblock();
    // Swal.fire(
    //   _t('Success!'),
    //   'Login',
    //   'success',
    // );
    // window.location.href = '/my-team';
  });
};

(async () => {
  if ($('.js-logout.game-db__logout').length) {
    checkMetamaskWithoutEx();
  }

  initLogin();
  logout();
  filters();
  mintNfts();
  reloadMyWallet();
  reloadMyWalletPage();
  transferNft();
  transferNftYoungPlayer();
  displayOwnerActions();
  tierToggle();
  initBuyTrainingCenter();
  initBuyFormation();
  matches();
  initMyTeam();
  initClaim();
  jerseyClaim();
  statDetail();
  reloadMyTokens();
  checkMyWalletBar();
  reloadPartnershipItems();
  reloadFormations();
  createTeam();
  playerNameChange();
  playerResetSkills();


  reloadMyMatches();
  putOnMarketplace();
  removeFromMarketplace();
  buyFromMarketplace();

  transferTrainingCenter();
  sellTrainingCenter();
  sellYoungPlayer();
  buyTrainingCenterFromMarketplace();
  buyYoungPlayerFromMarketplace();
  removeTrainingCenterFromMarketplace();
  removeYoungPlayerFromMarketplace();

  transferGear();
  sellGear();
  buyGearFromMarketplace();
  removeGearFromMarketplace();

  transferShoe();
  sellShoe();
  buyShoeFromMarketplace();
  removeShoeFromMarketplace();

  claimOneBoxDrop();
  openBox();
  initBuyBox();
  sellBox();
  removeBoxFromMarketplace();

  // Box Marketplace
  sellJersey();
  tranferJersey();
  initBuyJersey();
  removeJerseyFromMarketplace();
  initPlayerDetail();

  spinWheel();

  // getOwnerOf();

  joinCup();

  $('.js-reload-widget-interval').each((index, element) => {
    const widgetId = $(element).closest('[data-design-widget-id]').data('design-widget-id');
    const token = getToken();
    setInterval(() => {
      // block();
      $.post(`/ajax/widget/render?info_item_id=${window.itemId}&token=${token}&cms_design_widget_id=${widgetId}&is_ajax=1&chainId=${window.selectedChain === 'CHZ' ? window.chainIdChz : window.chainId}`, { type: $(element).data('type') }, (data) => {
        // unblock();
        $(`.widget[data-design-widget-id="${widgetId}"]`).html(data);
      }).done(() => {
        // localDatetime();
      });
    }, (Number($(element).data('interval')) * 1000));
  });
})();
